<template>
  <div class="checkbox-container">
    <input type="checkbox" :name="inputName" :id="inputId" v-model="isChecked" @input="setInput">
    <label :for="inputId">{{inputLabel}}</label>
  </div>
</template>

<script>
export default {
  props: {
    inputName: String,
    inputId: String,
    inputLabel: String,
    isInitChecked: Boolean,
    setInput: Function
  },
  data() {
    return {
      isChecked: this.isInitChecked
    };
  }
};
</script>

<style lang="scss" scoped>
.checkbox-container {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

label {
  font-size: 14px;
  margin: 0;
  line-height: 1.6;
  color: #1a1a1a;
  cursor: pointer;
}

input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin: 2px 0 0 0;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: #0066cc;
}
</style>
